"use client";

// Temps analytics (pageviews, page-leave, Web Vitals, engagement). Session
// replay is disabled — see the note on `enableSessionRecording` below.
//
// The SDK ships with "use client" directives, so it needs this wrapper to sit
// between it and the async Server Component root layout.
//
// No route handler is needed for `basePath`: `/api/_temps/*` is served by the
// Temps proxy in front of the deployed app, not by this Next app (LK_Auto has
// no such route either, and its POSTs to /api/_temps/session-replay/events
// return 200). Likewise there are no env vars to set — Temps injects them at
// deploy time.
//
// Off outside production builds (`next dev`). The SDK's own `ignoreLocalhost`
// only matches a literal localhost / 127.x / [::1] host, so dev opened by a LAN
// IP or another hostname still sent /api/_temps/event and /speed.
import { TempsAnalyticsProvider } from "@temps-sdk/react-analytics";

export function AnalyticsProvider({ children }: { children: React.ReactNode }) {
  return (
    <TempsAnalyticsProvider
      basePath="/api/_temps"
      disabled={process.env.NODE_ENV !== "production"}
      // Session replay is off: on iOS Safari it froze the page on navigation
      // (e.g. tapping the /db tab). Its history.pushState hook packs the whole
      // event buffer and takes a full rrweb snapshot of the page on the main
      // thread; the pending /api/_temps/event request was just the symptom.
      // Confirmed on device: `temps_session_recording_enabled = "false"` fixed
      // it with the rest of Temps analytics still on.
      enableSessionRecording={false}
    >
      {children}
    </TempsAnalyticsProvider>
  );
}
